import { ReactNode } from "react";

import { UniqueIdentifier } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

export type TSortableContainerProps = {
	id: UniqueIdentifier;
	children?: (
		setNodeRef: (node: HTMLElement | null) => void,
		listeners: SyntheticListenerMap | undefined,
	) => ReactNode;
};

export type TSortableItemProps = {
	id: UniqueIdentifier;
	children?: ReactNode;
};

export type TSortableProps = {
	id: UniqueIdentifier;
	children?: ReactNode;
};

export function SortableContainer({ id, children }: TSortableContainerProps) {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<div style={style} {...attributes}>
			{children?.(setNodeRef, listeners)}
		</div>
	);
}

export function Sortable({ id, children }: TSortableProps) {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<div ref={setNodeRef} style={style} {...attributes} {...listeners}>
			<div>{children}</div>
		</div>
	);
}
